class AI {
  constructor() {
    this.chatbot = {
      messages: []
    };
  }
}

// initial state
const state = () => (new AI());

// getters
const getters = {
  chatBotMessages: state => {
    return state.chatbot.messages;
  },
  chatBotWriting: state => {
    if(state.chatbot.messages.length == 0) {
      return false;
    }
    let lastMessage = state.chatbot.messages[state.chatbot.messages.length-1];
    return lastMessage.role == "assistant" && !lastMessage.end;
  },
}

// actions
const actions = {

}

// mutations
const mutations = {
  locale: function(state , payload) {
    state.locale = payload
  },
  addChatBotMessage: function(state, payload) {
    state.chatbot.messages.push(payload);
  },
  appendChatBotMessage: function(state, payload) {
    let lastMessage = state.chatbot.messages[state.chatbot.messages.length-1];
    lastMessage.content += payload;
  },
  closeChatBotMessage: function(state) {
    let lastMessage = state.chatbot.messages[state.chatbot.messages.length-1];
    lastMessage.end = true;
  },
  clearChatBotMessages: function(state) {
    state.chatbot.messages = [];
  },
}


export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations
}
